import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Format a string as title case (e.g. "JOHN DOE" -> "John Doe").
 * Use for staff/user display names throughout the portal.
 * @param {string} str
 * @returns {string}
 */
export function toTitleCase(str) {
  if (str == null || typeof str !== 'string') return '';
  const s = str.trim();
  if (!s) return '';
  return s
    .split(/\s+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}

/**
 * Format a date string to full format (e.g., "January 15, 2026")
 * @param {string|Date} dateString - The date to format
 * @param {object} options - Additional formatting options
 * @returns {string} Formatted date string
 */
export function formatDate(dateString, options = {}) {
  if (!dateString) return 'N/A';
  
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return 'Invalid Date';
    
    const defaultOptions = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      ...options
    };
    
    return date.toLocaleDateString('en-US', defaultOptions);
  } catch (error) {
    console.error('Error formatting date:', error);
    return 'Invalid Date';
  }
}

/**
 * Format a date with time to full format (e.g., "January 15, 2026 at 2:30 PM")
 * @param {string|Date} dateString - The date to format
 * @param {object} options - Additional formatting options
 * @returns {string} Formatted date and time string
 */
/**
 * Format birth date (day + month only, e.g. "25 December")
 * Accepts dd-mm-yyyy or dd-mm format.
 * @param {string} dobString
 * @returns {string}
 */
export function formatBirthday(dobString) {
  if (!dobString || typeof dobString !== 'string') return 'N/A';
  const trimmed = dobString.trim();
  if (!trimmed) return 'N/A';
  const parts = trimmed.split('-');
  if (parts.length < 2) return trimmed;
  const day = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10) - 1; // 0-indexed for Date
  if (isNaN(day) || isNaN(month) || month < 0 || month > 11 || day < 1 || day > 31) return trimmed;
  const date = new Date(2000, month, day);
  if (isNaN(date.getTime())) return trimmed;
  return date.toLocaleDateString('en-US', { month: 'long', day: 'numeric' });
}

export function formatDateTime(dateString, options = {}) {
  if (!dateString) return 'N/A';
  
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return 'Invalid Date';
    
    const defaultOptions = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
      ...options
    };
    
    return date.toLocaleDateString('en-US', defaultOptions);
  } catch (error) {
    console.error('Error formatting date time:', error);
    return 'Invalid Date';
  }
}




